import { defineMessages } from 'react-intl';

export default defineMessages({
  loginLabel: {
    id: 'site.components.docsHeader.actions.login',
    defaultMessage: 'Log in',
    description: 'label of the log in button',
  },
});
